module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_weibo.ac343.png";